import { useEffect, useLayoutEffect, useMemo } from "react";
import { fetchHomePage } from "../api/catalog";
import {
  applyStoreTheme,
  clearStoreTheme,
  readCachedStoreTheme,
  storeThemeFromSettings,
  writeCachedStoreTheme,
} from "../lib/storeTheme";

export default function StoreTheme({ storeSlug }) {
  const contentPage = useMemo(
    () => /\/pages\/[^/]+/.test(window.location.pathname),
    []
  );

  useLayoutEffect(() => {
    if (contentPage) return;
    const cached = readCachedStoreTheme(storeSlug);
    if (cached) applyStoreTheme(cached);
  }, [contentPage, storeSlug]);

  useEffect(() => {
    if (contentPage) return undefined;
    let cancelled = false;
    fetchHomePage(storeSlug)
      .then((data) => {
        if (cancelled) return;
        const theme = storeThemeFromSettings(data?.page?.content?.settings);
        writeCachedStoreTheme(storeSlug, theme);
        applyStoreTheme(theme);
      })
      .catch(() => {
        if (!cancelled) {
          writeCachedStoreTheme(storeSlug, null);
          clearStoreTheme();
        }
      });
    return () => {
      cancelled = true;
    };
  }, [contentPage, storeSlug]);

  return null;
}
